export default "__VITE_ASSET__BnYeeycH__"